import React from 'react';
import {
  CardContainer,
  Background,
  Card,
  TextInput,
  Text,
  Form,
  InputLabel,
  Button,
} from '@design-system/';
import { useDispatch, useSelector } from 'react-redux';
import { verify_email } from './redux/reducer';
import { getLoading } from './redux/selectors';
import * as Yup from 'yup';
import { useFormik } from 'formik';

const OTP = () => {
  const loading = useSelector(getLoading);
  const dispatch = useDispatch();
  const email = localStorage.getItem('email');
  const formik = useFormik({
    initialValues: {
      token: '',
    },
    onSubmit: async (data) => {
      const token = {
        confirm_email_token: data.token,
      };

      dispatch(verify_email(token));
    },
    validationSchema: Yup.object({
      token: Yup.string().required('Token is required.'),
    }),
  });

  return (
    <Background>
      <CardContainer>
        <Card>
          <Text size="large">Email Verification</Text>
          <Text size="small">
            To verify your email, enter the activation code sent to {email}
          </Text>
          <Form onSubmit={formik.handleSubmit}>
            <InputLabel htmlFor="email">Email </InputLabel>

            <TextInput
              name="token"
              id="otp"
              placeholder="Enter OTP"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.token}
            ></TextInput>
            {formik.touched.token && formik.errors.token ? (
              <Text color="red" align="left">
                {formik.errors.token}
              </Text>
            ) : null}
            <Button
              style={{ marginTop: 20 }}
              text={loading ? 'Verifying...' : 'Verify'}
              type="submit"
              bgColor="#549A9A"
              weight="500"
            />
          </Form>
        </Card>
      </CardContainer>
    </Background>
  );
};
export default OTP;
